import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import {AnalysisTemplateSelectorTemplate} from 'analysis-tool/graphql/AnalysisTemplateSelectorQuery';
import {getFileConfigVariables} from 'analysis-tool/templates/AnalysisTemplateVariableUtils';
import SimpleAnalysisTemplateSelector from 'analysis-tool/templates/SimpleAnalysisTemplateSelector';
import * as Colors from 'ui-library/Colors';

import {
  automationFileConfigStyles,
  AutomationOutputFileConfigEditorProps,
  SectionNumber,
} from '../AutomationFileConfigUtils';
import {OutputFileAction} from '../RunSchemaSpecConstants';

export default function AutomationOutputFileConfigAnalysisTemplateInfoSection(
  props: AutomationOutputFileConfigEditorProps
): JSX.Element {
  const [template, setTemplate] = useState<string | null>(
    props.outputFileConfig.analysisTemplate ? props.outputFileConfig.analysisTemplate : null
  );

  function handleSelectTemplate(newTemplate: AnalysisTemplateSelectorTemplate | null): void {
    setTemplate(newTemplate ? newTemplate.id : null);
    if (newTemplate) {
      props.onUpdateConfig({
        ...props.outputFileConfig,
        actionType: OutputFileAction.RUN_ANALYSIS_TEMPLATE,
        analysisTemplate: newTemplate.id,
        entitySchemaInfo: null,
        resultSchemaInfo: null,
        destinationInfo: null,
        transforms: [],
        columnTypes: null,
        columnTypesByName: {},
        datasetNameTemplateParts: undefined,
        shouldCreateDataset: false,
        datasetConfigJson: undefined,
        shouldAllowAttachment: false,
        shouldPerformPlateTransfer: false,
        shouldRecordImages: false,
      });
    } else {
      props.onUpdateConfig({
        ...props.outputFileConfig,
        analysisTemplate: null,
      });
    }
  }

  return (
    <div className={css(automationFileConfigStyles.subsection, automationFileConfigStyles.subsectionBorder)}>
      <SectionNumber sectionNumber={props.sectionNumber} />
      <div className={css(automationFileConfigStyles.innerTitle)}>Configure Analysis Template</div>
      <div
        className={css(automationFileConfigStyles.description, automationFileConfigStyles.sectionDescription)}
      >
        If an analysis template is selected, the unprocessed file will be sent to the analysis template. Only
        templates that accept file(s) as input can be selected.
      </div>
      <div className={css(styles.schemaInfoSectionRow)}>
        <div className={css(styles.outputFileConfigActionDropdown)}>
          <SimpleAnalysisTemplateSelector
            template={template ? {id: template} : null}
            onSelectTemplate={(newTemplate) => {
              handleSelectTemplate(newTemplate);
            }}
            filterTemplate={(template) =>
              template.dataFrameVariables.length === 0 &&
              getFileConfigVariables(template.configVariables).length === 1
            }
          />
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  schemaInfoSectionRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: '28px',
  },
  outputFileConfigActionDropdown: {
    flex: 0.33,
    marginRight: '32px',
  },
  tableTypeDropdown: {
    flex: 0.33,
    marginRight: '32px',
  },
  schemaActionButtons: {
    display: 'flex',
    flex: 0.2,
    justifyContent: 'flex-end',
    marginTop: '4px',
  },
  schemaDisplayContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginLeft: '-8px',
    alignItems: 'flex-start',
  },
  schemaName: {
    wordWrap: 'break-word',
    overflowWrap: 'anywhere',
    paddingLeft: '8px',
    paddingTop: '6px',
    paddingBottom: '6px',
    flex: 0.8,
  },
  active: {
    background: Colors.GRAY_LIGHTER,
  },
  hidden: {
    display: 'none',
  },
  schemaInfoSection: {
    flex: 0.33,
    marginRight: '32px',
  },
  actionCheckbox: {
    alignItems: 'center',
    display: 'flex',
  },
  checkboxInput: {
    marginBottom: '2px',
    width: '100%',
  },
});
